import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/index.scss';
import axios from 'axios';
import { API_BASE_URL, API_VERSION, API_PREFIX, API_PATHS } from '@/config/api';

// 导入LaTeX公式渲染库
import VueLatex from 'vatex';
import 'katex/dist/katex.min.css';

// 设置全局axios默认值
axios.defaults.baseURL = API_BASE_URL;
console.log('设置全局axios baseURL:', axios.defaults.baseURL);

// 导入模拟服务 (在设置默认值之后导入)
import './mock';

// 添加全局提示：开发环境使用模拟API
if (process.env.NODE_ENV === 'development') {
  console.log('%c开发环境使用模拟API', 'color: green; font-weight: bold; font-size: 14px;');
  console.log(`%c当前API版本: ${API_VERSION}`, 'color: blue;');
  console.log(`%c注册请求会发送到: ${API_PREFIX}${API_PATHS.AUTH.REGISTER}`, 'color: blue;');
}

// 添加全局样式
import './assets/styles/global.css'

// 创建事件总线
const EventBus = new Vue();
Vue.prototype.$bus = {
  on: (...args) => EventBus.$on(...args),
  off: (...args) => EventBus.$off(...args),
  emit: (...args) => EventBus.$emit(...args)
};

Vue.use(ElementUI, { size: 'medium' });
// 注册LaTeX公式渲染组件
Vue.use(VueLatex);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app'); 